import React, { createContext, useContext, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getUsuarios, getPermisos, getModulos } from '@helpers/api/mantenedores'
import { loadPermissions } from '@actions/permissionsActions'

const MantenedoresContext = createContext()

export const useMantenedores = () => useContext(MantenedoresContext)

export const MantenedoresProvider = ({ user, children }) => {
    // const [usuarios, setUsuarios] = useState([])
    // const [permisos, setPermisos] = useState([])
    // const [modulos, setModulos] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()

    // Obtiene los permisos procesados del state de Redux
    const userPermissions = useSelector(state => state.permissions?.permissions)
    const permissionsLoading = useSelector(state => state.permissions?.loading)
    const permissionsError = useSelector(state => state.permissions?.error)
    console.log('Permisos cargados:', userPermissions)

    useEffect(() => {
        let isMounted = true
        setLoading(true)
        setError(null)

        // Si no hay permisos en el state, los carga
        if (!userPermissions && user) {
            dispatch(loadPermissions(user))
        }
        setLoading(false)

        // Promise.all([getUsuarios(user), getPermisos(user), getModulos(user)])
        //     .then(([usuariosRes, permisosRes, modulosRes]) => {
        //         if (!isMounted) return
        //         setUsuarios(usuariosRes.success ? usuariosRes.data : [])
        //         setPermisos(permisosRes.success ? permisosRes.data : [])
        //         setModulos(modulosRes.success ? modulosRes.data : [])
        //         setLoading(false)
        //     })
        //     .catch(err => {
        //         if (!isMounted) return
        //         setError('Error al cargar datos de mantenedores')
        //         setLoading(false)
        //     })
        return () => {
            isMounted = false
        }
    }, [user, userPermissions, dispatch])

    // El loading del contexto depende del loading de Redux y de los datos locales
    const isLoading = loading || permissionsLoading
    const contextError = error || permissionsError

    return (
        <MantenedoresContext.Provider
            value={{
                // usuarios,
                // permisos,
                // modulos,
                userPermissions,
                loading: isLoading,
                error: contextError
            }}>
            {children}
        </MantenedoresContext.Provider>
    )
}

export { MantenedoresContext }
